(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["application-steps-inline-video"] && !Shopify.designMode) return;
  try {
    
  class ApplicationSteps extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.cards = Array.from(this.querySelectorAll('[data-step-card]'));

this.prevArrow = this.querySelector('[data-step-prev]');
this.nextArrow = this.querySelector('[data-step-next]');

this.prevArrow?.addEventListener('click', () => {
  if (this.activeIndex > 0) {
    this.select(this.activeIndex - 1, {
      scroll: true
    });
  }
});

this.nextArrow?.addEventListener('click', () => {
  if (this.activeIndex < this.cards.length - 1) {
    this.select(this.activeIndex + 1, {
      scroll: true
    });
  }
});

      this.scroller = this.querySelector('[data-cards]');
      this.stepMedia = this.querySelector('[data-step-media]');
      this.videoMount = this.querySelector('[data-video-mount]');
      this.posterGroup = this.querySelector('[data-poster-group]');
      this.playButton = this.querySelector('[data-play]');
      this.watchButton = this.querySelector('[data-watch]');
      this.caption = this.querySelector('[data-caption]');
      this.captionTitle = this.querySelector('[data-caption-title]');
      this.captionDescription = this.querySelector('[data-caption-description]');

      this.hasVideo = this.dataset.hasVideo === 'true';
      this.autoplay = this.dataset.autoplay === 'true';
      this.activeIndex = parseInt(this.dataset.activeIndex, 10) || 0;
      this.mode = this.hasVideo && this.dataset.initialMedia === 'video' ? 'video' : 'step';
      this.video = null;

      // Seed the slide cache with the step image Liquid already rendered.
      this.slides = new Map();
      if (this.stepMedia) {
        this.slides.set(this.activeIndex, Array.from(this.stepMedia.childNodes));
      }

      this.onCardClick = this.onCardClick.bind(this);
      this.onCardKeydown = this.onCardKeydown.bind(this);
      this.showVideo = this.showVideo.bind(this);

      this.cards.forEach((card) => {
        card.addEventListener('click', this.onCardClick);
        card.addEventListener('keydown', this.onCardKeydown);
      });

      if (this.playButton) this.playButton.addEventListener('click', this.showVideo);
      if (this.watchButton) this.watchButton.addEventListener('click', this.showVideo);

      // Pause when the media scrolls out of view.
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                this.pauseVideo();
                return;
              }

              // Optional autoplay: only once, and only if the section opened
              // on the video. Browsers still require the video to be muted.
              if (this.autoplay && this.mode === 'video' && !this.autoplayed) {
                this.autoplayed = true;
                this.showVideo();
              }
            });
          },
          { threshold: 0.35 }
        );
        const media = this.querySelector('[data-media]');
        if (media) this.observer.observe(media);
      }

      if (window.Shopify && window.Shopify.designMode) this.bindDesignMode();
    }

    disconnectedCallback() {
      this.pauseVideo();
      if (this.observer) this.observer.disconnect();
    }

    /* ------------------------------------------------------------ events */

    onCardClick(event) {
      const index = parseInt(event.currentTarget.dataset.index, 10);
      this.select(index, { scroll: true });
    }

    onCardKeydown(event) {
      const index = parseInt(event.currentTarget.dataset.index, 10);
      const last = this.cards.length - 1;
      let next = null;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          next = index === last ? 0 : index + 1;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          next = index === 0 ? last : index - 1;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = last;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.select(next, { focus: true, scroll: true });
    }

    /* ------------------------------------------------------------- state */

    select(index, options = {}) {
      const card = this.cards[index];
      if (!card) return;

      this.activeIndex = index;
this.updateNavigation();
      this.cards.forEach((item, itemIndex) => {
        const active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
      });

      if (options.focus) card.focus({ preventScroll: true });
      if (options.scroll) this.scrollIntoView(card);

      this.showStep(index);
    }

updateNavigation() {
  if (this.prevArrow) {
    this.prevArrow.disabled = this.activeIndex === 0;
  }

  if (this.nextArrow) {
    this.nextArrow.disabled =
      this.activeIndex === this.cards.length - 1;
  }
}

    scrollIntoView(card) {
      if (!this.scroller || !window.matchMedia('(max-width: 749px)').matches) return;

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const left = card.offsetLeft - this.scroller.offsetLeft - 20;

      this.scroller.scrollTo({ left, behavior: reduce ? 'auto' : 'smooth' });
    }

    /*
     * Returns (and caches) the nodes for a step. The step rendered by Liquid
     * is seeded into the cache on init, so returning to it after visiting
     * another step restores the original image instead of clearing the panel.
     */
    slideFor(index) {
      if (this.slides.has(index)) return this.slides.get(index);

      const card = this.cards[index];
      const blockId = card ? card.dataset.blockId : '';
      const template = blockId
        ? this.querySelector(`template[data-step-template="${CSS.escape(blockId)}"]`)
        : null;

      const nodes = template
        ? Array.from(template.content.cloneNode(true).childNodes)
        : [];

      this.slides.set(index, nodes);
      return nodes;
    }

 
showStep(index) {
  const card = this.cards[index];
  if (!card) return;

  this.hideVideo();
  this.mode = 'step';

  const nodes = this.slideFor(index);
  this.stepMedia.replaceChildren(...nodes);

  const hasStepImage = nodes.some(node =>
    node.nodeType === 1 &&
    (node.matches('img, picture') || node.querySelector('img'))
  );

  this.stepMedia.hidden = !hasStepImage;

  if (this.posterGroup) {
    this.posterGroup.hidden = hasStepImage;
  }

  if (this.watchButton) {
    this.watchButton.hidden = !this.hasVideo || !hasStepImage;
  }

  this.updateCaption(card);

  if (!hasStepImage && this.caption) {
    this.caption.hidden = true;
  }
}


    updateCaption(card) {
      if (!this.caption) return;

      const titleEl = card.querySelector('.application-step-card__title');
      const descEl = card.querySelector('.application-step-card__description');
      const title = titleEl ? titleEl.textContent.trim() : '';

      if (this.captionTitle) this.captionTitle.textContent = title;
      if (this.captionDescription) {
        this.captionDescription.innerHTML = descEl ? descEl.innerHTML : '';
      }

      this.caption.hidden = !title;
    }

    /* ------------------------------------------------------------- video */

    showVideo() {
      if (!this.hasVideo) return;

      const template = this.querySelector('template[data-video-template]');
      if (!template) return;

      this.mode = 'video';
      this.stepMedia.hidden = true;
      if (this.posterGroup) this.posterGroup.hidden = true;
      if (this.caption) this.caption.hidden = true;
      if (this.watchButton) this.watchButton.hidden = true;

      // The video element is built once and then reused, so returning to it
      // resumes where the visitor left off instead of reloading the file.
      if (!this.video) {
        this.videoMount.replaceChildren(template.content.cloneNode(true));
        this.video = this.videoMount.querySelector('video');

        if (this.video) {
          this.video.setAttribute('playsinline', '');
          this.video.preload = 'metadata';
          this.video.addEventListener('ended', () => {
            if (!this.video.loop) this.restorePoster();
          });
        }
      }

      this.videoMount.hidden = false;

      if (!this.video) return;

      const promise = this.video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(() => {
          // Playback refused (sound-on autoplay policies). Keep the video on
          // screen with its native controls so the visitor can start it, and
          // only fall back to the poster when there are no controls to use.
          if (this.video && this.video.controls) return;
          this.restorePoster();
        });
      }
    }

    /* Hide the video without destroying it. */
    hideVideo() {
      this.pauseVideo();
      this.videoMount.hidden = true;
    }

    restorePoster() {
      this.hideVideo();
      if (this.posterGroup) this.posterGroup.hidden = false;
    }

    pauseVideo() {
      if (this.video && !this.video.paused) {
        try {
          this.video.pause();
        } catch (error) {
          /* no-op */
        }
      }
    }

    teardownVideo() {
      this.pauseVideo();
      if (this.video) {
        this.video.removeAttribute('src');
        this.video.load();
        this.video = null;
      }
      this.videoMount.replaceChildren();
      this.videoMount.hidden = true;
    }

    /* ------------------------------------------------------ Theme Editor */

    bindDesignMode() {
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        const index = parseInt(event.target.dataset.index, 10);
        if (!Number.isNaN(index)) this.select(index, { scroll: true });
      });
    }
  }

  if (!customElements.get('application-steps')) {
    customElements.define('application-steps', ApplicationSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
